import React, { useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import { Menu } from "@mui/icons-material";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toAbsoluteUrl } from "../../../../../_metronic";
import NestedList from "../../../../partials/content/NestedList";
import CookiesPolicies from "./CookiesPolicies";
import Disclaimer from "./Disclaimer";
import EulaPolicies from "./EulaPolicies";
import PrivacyPolicies from "./PrivacyPolicies";
import ReturnRefund from "./ReturnRefund";
import TermsConditions from "./TermsConditions";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { Image } from "react-bootstrap";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: "-25px",
    marginLeft: "-25px",
    marginRight: "-25px",
    backgroundColor: "#ffffff",
    minHeight: `calc( 100vh - 119px )`,
    maxHeight: `calc( 100vh - 119px )`,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
    color: "white",
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    [theme.breakpoints.up("sm")]: {
      marginTop: "-25px",
      minHeight: `calc( 100vh - 119px )`,
      maxHeight: `100%`,
    },
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: drawerWidth + theme.spacing(3),
    },
    padding: theme.spacing(3),
    overflowY: "auto",
  },
}));

function LegalStatement({ history }, props) {
  const { companyProfile, userPreferences } = useGlobalData();
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const today = DateTime.now().year;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [component, setComponent] = useState(<TermsConditions />);

  const lists = [
    {
      key: "Terms & Conditions",
      label: "Terms & Conditions",
      icon: "",
    },
    {
      key: "Privacy Policy",
      label: "Privacy Policy",
      icon: "",
    },
    {
      key: "Cookie Policy",
      label: "Cookie Policy",
      icon: "",
    },
    {
      key: "Disclaimer",
      label: "Disclaimer",
      icon: "",
    },
    {
      key: "End-User License Agreement",
      label: "End-User License Agreement",
      icon: "",
    },
    {
      key: "Return & Refund Policy",
      label: "Return & Refund Policy",
      icon: "",
    },
  ];

  const defaultSelected = "Terms & Conditions";

  async function handleSelectItem(key) {
    let component;
    switch (key) {
      case "Terms & Conditions":
        component = <TermsConditions />;
        break;
      case "Privacy Policy":
        component = <PrivacyPolicies />;
        break;
      case "Cookie Policy":
        component = <CookiesPolicies />;
        break;
      case "Disclaimer":
        component = <Disclaimer />;
        break;
      case "End-User License Agreement":
        component = <EulaPolicies />;
        break;
      case "Return & Refund Policy":
        component = <ReturnRefund />;
        break;
      default:
        component = <TermsConditions />;
        break;
    }
    setComponent(component);
  }

  const drawer = (
    <div>
      <div
        className={classes.toolbar}
        style={{ marginTop: "10px", marginBottom: "10px" }}
      >
        <div className="d-flex flex-column align-items-center justify-content-between">
          <a href="http://invifo.com" target="_blank" rel="noopener noreferrer">
            <Typography align="center">
              <Image
                src={toAbsoluteUrl("/media/logos/logo-mini-lg.png")}
                style={{
                  width: "5rem",
                  height: "auto",
                }}
                alt="Invifo Enterprise Logo"
                fluid
              />
            </Typography>
          </a>
        </div>
        <Typography variant="subtitle1" align="center">
          <strong>
            {today.toString()}&nbsp;&copy;&nbsp;
            <a
              href="http://invifo.com"
              target="_blank"
              rel="noopener noreferrer"
              className="kt-link text-hover-primary"
            >
              Invifo Enterprise
            </a>
            .
          </strong>
        </Typography>
        <Typography variant="subtitle1" align="center">
          <strong>All Rights Reserved.</strong>
        </Typography>
        <Typography variant="subtitle2" align="center">
          {companyProfile.platformVersion}
        </Typography>
      </div>
      <Divider />
      <NestedList
        lists={lists}
        onSelectItem={handleSelectItem}
        defaultSelected={defaultSelected}
      />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const actionButtons = [];
  actionButtons.push({
    title: "",
    color: "label-brand",
    icon: "fas fa-backward",
    onClick: () => {
      history.push("/menu");
    },
  });

  return (
    <React.Fragment>
      <PageSubHeader
        title="Legal Statement"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/common/legalStatement",
            title: "Legal Statements",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <div className={classes.root}>
        <CssBaseline />
        <Hidden smUp implementation="css">
          <AppBar
            className={classes.appBar}
            style={{
              backgroundAttachment: "fixed",
              backgroundImage: `${
                userPreferences.invifoThemeID > 0
                  ? `url(${toAbsoluteUrl(
                      `/media/bg/${userPreferences.invifoTheme.imageName}`
                    )})`
                  : userPreferences.customThemeID > 0
                  ? "url(" + userPreferences.customTheme.imagePath + ")"
                  : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
              }`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              position: "unset",
            }}
          >
            <Toolbar>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <Menu />
              </IconButton>
              <Typography className="text-white" variant="h6" noWrap>
                Legal Statement
              </Typography>
            </Toolbar>
          </AppBar>
        </Hidden>
        <Hidden xsDown implementation="css">
          <AppBar
            className={classes.appBar}
            style={{
              backgroundAttachment: "fixed",
              backgroundImage: `${
                userPreferences.invifoThemeID > 0
                  ? `url(${toAbsoluteUrl(
                      `/media/bg/${userPreferences.invifoTheme.imageName}`
                    )})`
                  : userPreferences.customThemeID > 0
                  ? "url(" + userPreferences.customTheme.imagePath + ")"
                  : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
              }`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              position: "unset",
            }}
          >
            <Toolbar>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <Menu />
              </IconButton>
              <Typography className="text-white" variant="h6" noWrap>
                Legal Statement
              </Typography>
            </Toolbar>
          </AppBar>
        </Hidden>
        <nav className={classes.drawer}>
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>{component}</main>
      </div>
    </React.Fragment>
  );
}

export default LegalStatement;
